import { render, staticRenderFns } from "./HalloweenHero.vue?vue&type=template&id=390e8026&"
import script from "./HalloweenHero.vue?vue&type=script&lang=js&"
export * from "./HalloweenHero.vue?vue&type=script&lang=js&"
import style0 from "./HalloweenHero.vue?vue&type=style&index=0&id=390e8026&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports